"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeBase64Attachment = decodeBase64Attachment;
exports.isAttachment = void 0;
var _base64Helpers = require("./base64Helpers");
var SIGNATURE_ATTACHMENT = 'x0lG';
var SIGNATURE_GIF = 'R0lG';
var SIGNATURE_JPG = "/9j/";
var SIGNATURE_PNG = "iVBO";
var SIGNATURE_TIF = "SUkq";
var PICTURE_FILENAME = "Picture";
var getSignature = function getSignature(base64) {
  return base64.substring(0, 4);
};
var isAttachment = function isAttachment(base64) {
  return getSignature(base64) === SIGNATURE_ATTACHMENT;
};
exports.isAttachment = isAttachment;
function getAttachmentExtension(signature) {
  switch (signature) {
    case SIGNATURE_GIF:
      return '.gif';
    case SIGNATURE_JPG:
      return '.jpg';
    case SIGNATURE_PNG:
      return '.png';
    case SIGNATURE_TIF:
      return '.tif';
    default:
      return '.bmp';
  }
}
function getInt32(byteArray, offset) {
  var value = 0;
  for (var i = 0; i < 4; i += 1) {
    value |= byteArray[offset + i] << i * 8;
  }
  return value;
}
function getUnicodeString(byteArray, length, offset) {
  var charCodes = new Array(length),
    i = 0,
    currentOffset;
  for (; i < length; i += 1) {
    currentOffset = offset + i * 2;
    charCodes[i] = byteArray[currentOffset] | byteArray[currentOffset + 1] << 8;
  }
  return String.fromCharCode.apply(String, charCodes);
}

// String -> { name: String, bytes: Uint8Array }
function decodeBase64Attachment(attachmentBase64) {
  var allBytes = (0, _base64Helpers.base64ToArray)(attachmentBase64);
  var fileName;
  var fileBytes;
  if (!isAttachment(attachmentBase64)) {
    var signature = getSignature(attachmentBase64);
    fileName = PICTURE_FILENAME + getAttachmentExtension(signature);
    fileBytes = allBytes;
  } else {
    var fileNameLength = getInt32(allBytes, 20);
    fileName = getUnicodeString(allBytes, fileNameLength - 1, 24);
    fileBytes = allBytes.subarray(24 + fileNameLength * 2);
  }
  return {
    name: fileName,
    bytes: fileBytes
  };
}